<template>
  <div>
    <h1 class="mb-8 text-3xl font-bold">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('admin.krs.index')">
        KRS &amp; KHS
      </inertia-link>
      <span class="font-medium text-indigo-400">/</span>
      <inertia-link
        class="text-indigo-400 hover:text-indigo-600"
        :href="route('mahasiswa.edit', report.mst_mahasiswa_id)">
        {{ mahasiswa.name }}
      </inertia-link>
      <span class="font-medium text-indigo-400">/</span>
      Tahun: {{ report.school_year }}
      <span class="font-medium text-indigo-400">/</span>
      Semester: {{ report.school_semester }}
      <span class="font-medium text-indigo-400">/</span>
      NIM: {{ mahasiswa.nim }}
    </h1>
    <trashed-message
      v-if="report.deleted_at"
      class="mb-6"
      @restore="restore">
      This report KRS has been deleted.
    </trashed-message>
    <div class="overflow-hidden w-full bg-white rounded-md shadow md:max-w-3xl">
      <form @submit.prevent="update(krs)">
        <h3 class="pl-8 mt-6 text-2xl font-bold">
          Kartu Rencana Studi
        </h3>
        <div class="flex flex-wrap py-4 px-8">
          <text-input
            v-model="krs.school_year"
            :error="krs.errors.school_year"
            class="pr-6 pb-8 w-full lg:w-1/3"
            input-class="bg-gray-200"
            label="Tahun Ajaran"
            disabled />
          <text-input
            v-model="krs.school_semester"
            :error="krs.errors.school_semester"
            class="pr-6 pb-8 w-full lg:w-1/3"
            input-class="bg-gray-200"
            label="Semester"
            disabled />
          <text-input
            v-model="krs.krs_sks"
            :error="krs.errors.krs_sks"
            class="pr-6 pb-6 w-full lg:w-1/3"
            input-class="bg-gray-200"
            label="SKS KRS"
            disabled />
          <div tabindex="0" class="w-full border collapse border-base-300">
            <div class="text-xl font-medium collapse-title">
              Status verifikasi KRS :
              {{
                krs.krs_file_verified
                  ? `VERIF - ${report.krs_verif_fdate}`
                  : "BELUM VERIF"
              }}
            </div>
            <div class="collapse-content">
              <p class="my-2">
                - Scan file KRS:
                {{
                  report.krs_file
                    ? "ADA (Klik tombol [Lihat Gambar Scan KRS] untuk melihat)"
                    : "BELUM ADA"
                }}
              </p>
              <p class="my-2">
                - Operator Verifikasi:
                {{ report.krs_verif_operator }}
              </p>
              <p class="my-2">
                - Tanggal Verifikasi:
                {{ report.krs_verified_date }}
              </p>
            </div>
          </div>
        </div>
        <div class="flex justify-end mx-2 mt-2">
          <text-input
            v-model="krs.krs_file_reason"
            :error="krs.errors.krs_file_reason"
            class="pr-6 pb-8 w-full lg:w-1/2"
            label="Keterangan verifikasi" />
          <select-input
            v-model="krs.krs_file_verified"
            class="pr-6 pb-8 w-full lg:w-1/4"
            label="Status KRS">
            <option :value="null">
              BELUM VERIF
            </option>
            <option :value="1">
              VERIF
            </option>
          </select-input>
        </div>
        <div class="flex justify-end mx-8 mb-2 -mt-2">
          <span class="text-sm italic">*) Pastikan klik tombol [Update KRS] setelah melakukan
            perubahan status verifikasi</span>
        </div>
        <div class="flex items-center py-4 px-8 bg-gray-50 border-t border-gray-100">
          <button
            v-if="report.krs_file"
            class="btn-green"
            type="button"
            @click.prevent="showModal('krs_file')">
            Lihat Gambar Scan KRS
          </button>
          <loading-button
            :loading="krs.processing"
            class="ml-auto btn-indigo"
            type="submit">
            Update KRS
          </loading-button>
        </div>
      </form>
      <div class="divider" />
      <form @submit.prevent="update(khs)">
        <h3 class="pl-8 text-2xl font-bold">
          Kartu Hasil Studi
        </h3>
        <div class="flex flex-wrap py-4 px-8">
          <text-input
            v-model="khs.ip"
            :error="khs.errors.ip"
            class="pr-6 pb-8 w-full lg:w-1/3"
            label="IP Semester (GPA)"
            input-class="bg-gray-200"
            disabled />
          <text-input
            v-model="khs.ipk"
            :error="khs.errors.ipk"
            class="pr-6 pb-8 w-full lg:w-1/3"
            label="IP Kumulatif (CGPA)"
            input-class="bg-gray-200"
            disabled />
          <text-input
            v-model="khs.khs_sks"
            :error="khs.errors.khs_sks"
            class="pr-6 pb-6 w-full lg:w-1/3"
            label="SKS KRS"
            input-class="bg-gray-200"
            disabled />
          <div tabindex="0" class="mb-8 w-full border collapse border-base-300">
            <div class="text-xl font-medium collapse-title">
              Status verifikasi KHS :
              {{
                khs.khs_file_verified
                  ? `VERIF - ${report.khs_verif_fdate}`
                  : "BELUM VERIF"
              }}
            </div>
            <div class="collapse-content">
              <p class="my-2">
                - Scan file KHS:
                {{
                  report.khs_file
                    ? "ADA (Klik tombol [Lihat Gambar Scan KHS] untuk melihat)"
                    : "BELUM ADA"
                }}
              </p>
              <p class="my-2">
                - Operator Verifikasi:
                {{ report.khs_verif_operator }}
              </p>
              <p class="my-2">
                - Tanggal Verifikasi:
                {{ report.khs_verified_date }}
              </p>
            </div>
          </div>
        </div>
        <div class="flex justify-end mx-2 mt-2">
          <text-input
            v-model="khs.khs_file_reason"
            :error="khs.errors.khs_file_reason"
            class="pr-6 pb-8 w-full lg:w-1/2"
            label="Keterangan verifikasi" />
          <select-input
            v-model="khs.khs_file_verified"
            class="pr-6 pb-8 w-full lg:w-1/4"
            label="Status KHS">
            <option :value="null">
              BELUM VERIF
            </option>
            <option :value="1">
              VERIF
            </option>
          </select-input>
        </div>
        <div class="flex justify-end mx-8 mb-2 -mt-2">
          <span class="text-sm italic">*) Pastikan klik tombol [Update KHS] setelah melakukan
            perubahan status verifikasi</span>
        </div>
        <div class="flex items-center py-4 px-8 bg-gray-50 border-t border-gray-100">
          <button
            v-if="report.khs_file"
            class="btn-green"
            type="button"
            @click.prevent="showModal('khs_file')">
            Lihat Gambar Scan KHS
          </button>
          <loading-button
            :loading="khs.processing"
            class="ml-auto btn-indigo"
            type="submit">
            Update KHS
          </loading-button>
        </div>
      </form>
      <div class="divider" />
      <form @submit.prevent="update(payment)">
        <h3 class="pl-8 text-2xl font-bold">
          Kelayakan dan Pembayaran Beasiswa
        </h3>
        <div class="py-4 px-8">
          <div tabindex="0" class="mr-6 mb-0 w-full border collapse border-base-300">
            <div class="flex flex-wrap px-2 text-lg font-medium collapse-title">
              <select-input
                v-model="payment.approval_status_payment_id"
                :error="payment.errors.approval_status_payment_id
                "
                class="w-full md:w-1/3"
                label="Persetujuan Pembayaran">
                <option
                  v-for="option in approvalStatusOptions"
                  :key="option.id"
                  :value="option.id">
                  {{ option.status }}
                </option>
              </select-input>
              <select-input
                v-model="payment.payment_status_id"
                :error="payment.errors.payment_status_id"
                class="ml-1 w-full md:w-1/3"
                label="Status Pembayaran">
                <option :value="null">
                  N/A
                </option>
                <option
                  v-for="option in paymentStatusOptions"
                  :key="option.id"
                  :value="option.id">
                  {{ option.status }}
                </option>
              </select-input>
              <text-input
                v-model="payment.payment_status_reason"
                :error="payment.errors.payment_status_reason"
                class="w-full md:w-4/5"
                label="Keterangan" />
            </div>
            <div class="w-full">
              <table class="table-fixed">
                <thead>
                  <tr>
                    <th class="py-2 px-4 text-left text-light-blue-600 border-b">
                      No Transaksi
                    </th>
                    <th class="py-2 px-4 text-left text-light-blue-600 border-b">
                      Tanggal
                    </th>
                    <th class="py-2 px-4 text-right text-light-blue-600 border-b">
                      Jumlah
                    </th>
                    <th class="py-2 px-4 text-left text-light-blue-600 border-b">
                      Bank
                    </th>
                    <th class="py-2 px-4 text-right text-light-blue-600 border-b">
                      Status
                    </th>
                    <th />
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="detail in payments" :key="detail.id">
                    <td class="py-2 px-4 text-left">
                      {{ detail.payment_no }}
                    </td>
                    <td class="py-2 px-4 text-left">
                      {{ detail.payment_date }}
                    </td>
                    <td class="py-2 px-4 text-right">
                      {{
                        formatNumber(
                          detail.payment_amount
                        )
                      }}
                    </td>
                    <td class="py-2 px-4 text-left">
                      {{ detail.bank }}
                    </td>
                    <td class="py-2 px-4 text-left">
                      {{ detail.status }}
                    </td>
                    <td class="py-2 px-4 text-right">
                      <a
                        :href="route(
                          'payment.edit',
                          detail.id
                        )
                        "
                        class="font-bold text-indigo-400 underline hover:text-indigo-600">Lihat</a>
                    </td>
                  </tr>
                  <tr v-if="payments.length === 0">
                    <td class="py-4 px-6 border-t" colspan="6">
                      No payment data found.
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="flex items-center py-4 px-8 bg-gray-50 border-t border-gray-100">
          <inertia-link class="btn-green" :href="route('payment.create', report.id)">
            <span>Add Detail</span>
            <span class="hidden md:inline">Pembayaran</span>
          </inertia-link>
          <loading-button class="ml-auto btn-indigo" type="submit">
            Update Pembayaran
          </loading-button>
        </div>
      </form>
    </div>
    <modal :is-modal-show="isModalVisible" @close="closeModal">
      <template slot="header">
        {{ modalTextHeader }}
      </template>
      <template slot="body">
        <div class="flex justify-center">
          <blob-image :src="imgUrl" />
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import Modal from '@/Shared/Modal'
import BlobImage from '@/Shared/BlobImage'
import Swal from 'sweetalert2'
import { useForm, Link } from '@inertiajs/vue2'

export default {
    metaInfo () {
        return {
            title: `${this.mahasiswa.name}`,
        }
    },
    components: {
        LoadingButton,
        SelectInput,
        TextInput,
        TrashedMessage,
        Modal,
        BlobImage,
        'inertia-link': Link,
    },
    layout: Layout,
    props: {
        report: Object,
        mahasiswa: Object,
        approvalStatusOptions: Array,
        paymentStatusOptions: Array,
        payments: Array,
    },
    remember: 'form',
    data () {
        return {
            imgUrl: null,
            isModalVisible: false,
            modalTextHeader: 'Hasil scan',
            krs: useForm({
                school_year: this.report.school_year.toString(),
                school_semester: this.report.school_semester.toString(),
                krs_sks: this.report.krs_sks.toString(),
                krs_file: null,
                krs_file_reason: this.report.krs_file_reason,
                krs_file_verified: this.report.krs_file_verified,
                krs_verified_operator: this.report.krs_verified_operator,
                _utype: 'krs',
            }),
            khs: useForm({
                ip: this.report.ip,
                ipk: this.report.ipk,
                khs_sks: this.report.khs_sks
                    ? this.report.khs_sks.toString()
                    : '0',
                khs_file: null,
                khs_file_reason: this.report.khs_file_reason,
                khs_file_verified: this.report.khs_file_verified,
                khs_verified_operator: this.report.khs_verified_operator,
                _utype: 'khs',
            }),
            payment: useForm({
                payment_status_id: this.report.payment_status_id,
                approval_status_payment_id:
                    this.report.approval_status_payment_id,
                payment_status_reason: this.report.payment_status_reason,
                _utype: 'payment',
            }),
        }
    },
    methods: {
        update (form) {
            Swal.fire({
                title: 'Konfirmasi',
                text: 'Apakah anda yakin ingin mengupdate info verifikasi data?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes',
            }).then((result) => {
                if (result.isConfirmed) {
                    form.post(this.route('admin.krs.update', this.report.id), {
                        onSuccess: () => this.krs.reset('krs_file'),
                    })
                }
            })
        },
        showModal (docType) {
            this.imgUrl =
                docType === 'krs_file'
                    ? `/preview/${this.report.krs_file}`
                    : `/preview/${this.report.khs_file}`
            this.modalTextHeader =
                docType === 'krs_file' ? 'Gambar scan KRS' : 'Gambar scan KHS'
            this.isModalVisible = true
        },
        closeModal () {
            this.isModalVisible = false
        },
        formatNumber (num) {
            return num ? num.toLocaleString('id-ID') : '0'
        },
    },
}
</script>
